module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("HAT")]), _vm._v(" S"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("TALIN")]), _c('br'), _vm._v("K"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("NEW")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('span', {
    staticClass: "small2"
  }, [_vm._v("THE")]), _c('br'), _vm._v("E"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("NIGMA OF")]), _c('br'), _vm._v("B"), _c('span', {
    staticClass: "small2"
  }, [_vm._v("ARBAROSSA")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("David E. Murphy")]), _vm._v(" "), _c('p', [_vm._v("Yale University Press   New Haven & London")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95623314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/title.vue
// module id = 60
// module chunks = 0